import React, { useState } from 'react';
import { Info, CheckCircle, AlertTriangle, XCircle, X } from 'lucide-react';
import { cn } from '../utils/cn';
const variants = {
  info: {
    container: 'bg-surface-secondary border-edge-strong text-neutral-800',
    icon: 'text-fg-tertiary',
    Icon: Info,
  },
  success: {
    container: 'bg-success-50 border-success-200 text-success-800',
    icon: 'text-success-500',
    Icon: CheckCircle,
  },
  warning: {
    container: 'bg-warning-50 border-warning-200 text-warning-800',
    icon: 'text-warning-500',
    Icon: AlertTriangle,
  },
  error: {
    container: 'bg-danger-50 border-danger-200 text-danger-800',
    icon: 'text-danger-500',
    Icon: XCircle,
  },
};
export function Alert({
  variant = 'info',
  title,
  children,
  dismissible = false,
  onDismiss,
  className,
}) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  const config = variants[variant];
  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };
  return (
    <div
      role="alert"
      className={cn('flex gap-3 rounded-lg border p-4', config.container, className)}
    >
      <config.Icon size={20} className={cn('shrink-0 mt-0.5', config.icon)} aria-hidden="true" />
      <div className="flex-1 min-w-0">
        {title && <h3 className="text-sm font-semibold">{title}</h3>}
        <div className={cn('text-sm', title && 'mt-1')}>{children}</div>
      </div>
      {dismissible && (
        <button
          type="button"
          onClick={handleDismiss}
          className="shrink-0 text-current opacity-50 hover:opacity-100 transition-opacity"
          aria-label="Dismiss"
        >
          <X size={16} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
